import { createFileRoute, Outlet } from "@tanstack/react-router";

/** The payouts: the queues and the rest, and one payout's page. */
export const Route = createFileRoute("/_app/money/payouts")({
  component: Outlet,
});
